import { useHeaderHeight } from '@react-navigation/elements';
import {
  KeyboardAvoidingView as RNKeyboardAvoidingView,
  KeyboardAvoidingViewProps,
  Platform,
} from 'react-native';
import { isIphoneX } from 'react-native-iphone-x-helper';

export default function KeyboardAvoidingView(props: KeyboardAvoidingViewProps) {
  const headerHeight = useHeaderHeight();
  return (
    <RNKeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      keyboardVerticalOffset={headerHeight + (isIphoneX() ? -34 : 0)}
      {...props}
    />
  );
}
